import { render, staticRenderFns } from "./AlertBox.vue?vue&type=template&id=4cf1c27b&scoped=true"
import script from "./AlertBox.vue?vue&type=script&lang=js"
export * from "./AlertBox.vue?vue&type=script&lang=js"
import style0 from "./AlertBox.vue?vue&type=style&index=0&id=4cf1c27b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf1c27b",
  null
  
)

export default component.exports